import { shallowMount } from "@vue/test-utils";
import OfferTimeline from "@/components/core/custom/OfferTimeline.vue";

describe("OfferTimeline component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(OfferTimeline, {
      propsData: {
        userIsClient: true,
        tituloTimeline: {
          cliente: "Título para cliente",
          noCliente: "Título para no cliente"
        },
        steps: {
          cliente: ["Paso 1", "Paso 2", "Paso 3"],
          noCliente: ["Paso A", "Paso B"]
        },
        disclaimerTimeline: {
          title: "Título para disclaimerTimeline",
          subtitle: "Subtítulo para disclaimerTimeline"
        }
      }
    });
  });
  it("Renders del component OfferTimeline", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
